import React, { useState } from "react";
import useRevealSequence from "../useRevealSequence";
import Celebration from "../Celebration";

/**
 * Royal Winner - a ring feeding a crowned centre.
 *
 * The yantras stand in a circle around an empty throne. A light runs the
 * ring while the round finishes; when the result is in, the light slows
 * onto the winner and that yantra flies into the middle and takes the
 * crown.
 */

const RX = 290;
const RY = 250;
const CX = 410;
const CY = 372;
const RUN_IN_STEPS = 5;

export default function RoyalWinner({ tiles, winnerIndex, onFinished }) {
  const count = tiles.length;
  const step = 360 / Math.max(1, count);

  const [active, setActive] = useState(0);
  const [crowned, setCrowned] = useState(-1);
  const [landed, setLanded] = useState(-1);

  useRevealSequence(
    async (ctx) => {
      let at = 0;
      while (ctx.winnerIndex() < 0) {
        at = (at + 1) % count;
        setActive(at);
        await ctx.sleep(80);
      }
      const target = ctx.winnerIndex();

      // Always the same short run in, wherever the winner sits: step back
      // a fixed distance from it and walk that.
      const steps = RUN_IN_STEPS;
      at = (target - steps + count * 2) % count;
      for (let n = 1; n <= steps; n++) {
        at = (at + 1) % count;
        setActive(at);
        const t = n / steps;
        await ctx.sleep(28 + 150 * t * t);
      }

      await ctx.sleep(90);
      setCrowned(target); // the winner leaves the ring for the throne
      await ctx.sleep(320);
      setLanded(target);
      await ctx.sleep(1200);
      onFinished();
    },
    winnerIndex,
    [count],
  );

  const winner = landed >= 0 ? tiles[landed] : null;
  const throne = crowned >= 0 ? tiles[crowned] : null;

  return (
    <div className="rv-royal">
      <div className={`rv-royal-core ${throne ? "rv-royal-core--full" : ""}`}>
        {throne ? (
          <>
            <div className="rv-royal-crown">👑</div>
            <img src={throne.img} alt={throne.name || "winner"} />
            <div className="rv-royal-name">{throne.name}</div>
          </>
        ) : (
          <div className="rv-royal-empty">
            <span>👑</span>
            <small>Throne</small>
          </div>
        )}
      </div>

      {tiles.map((tile, i) => {
        const a = ((i * step - 90) * Math.PI) / 180;
        const gone = crowned === i;
        return (
          <div
            key={tile.id}
            className={[
              "rv-card rv-card--float",
              i === active && crowned < 0 ? "rv-card--active" : "",
              gone ? "rv-card--gone" : "",
              crowned >= 0 && !gone ? "rv-card--fade" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            style={{
              left: `${CX + Math.cos(a) * RX}px`,
              top: `${CY + Math.sin(a) * RY}px`,
            }}
          >
            <img src={tile.img} alt={tile.name || ""} />
            <span>{tile.name}</span>
          </div>
        );
      })}

      {winner ? <Celebration tile={winner} seed={landed} compact /> : null}
    </div>
  );
}
